import { makeRequest } from 'utils/requestLogger';

export default () =>
    makeRequest('get', '/api/recents/participant');


// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/getRecentRoundTablesParticipant.js